import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import ServicesGrid from "@/sections/ServicesGrid";
import Process from "@/sections/Process";
import WhyDatavib from "@/sections/WhyDatavib";
import References from "@/sections/References";
import About from "@/sections/About";
import Contact from "@/sections/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      // small delay to allow layout
      const t = setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  useEffect(() => {
    document.title = "DATAVIB | Kestirimci Bakım & Endüstriyel Servis Çözümleri";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ServicesGrid />
        <Process />
        <WhyDatavib />
        <References />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
